import React from "react";
import "./sources.css";

function Sources() {
  return (
    <div>
      <div className="sourcesParent">
        <h1>Sources</h1>
        <div className="sources">
          <li>
            Alavi, A., Bogu, G. K., Wang, M., Rangan, E. S., Brooks, A. W.,
            Wang, Q., Higgs, E., Celli, A., Mishra, T., Metwally, A. A., Cha,
            K., Knowles, P., Alavi, A. A., Bhasin, R., Panchamukhi, S., Celis,
            D., Aditya, T., Honkala, A., Rolnik, B., … Snyder, M. P. (2021, June
            21). Real-time alerting system for covid-19 using wearable data.
            medRxiv : the preprint server for health sciences.
            https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8240687/.{" "}
          </li>
          <li>
            Alavi, A., Bogu, G. K., Wang, M., Rangan, E. S., Brooks, A. W.,
            Wang, Q., Higgs, E., Celli, A., Mishra, T., Metwally, A. A., Cha,
            K., Knowles, P., Alavi, A. A., Bhasin, R., Panchamukhi, S., Celis,
            D., Aditya, T., Honkala, A., Rolnik, B., … Snyder, M. P. (2021,
            January 1). Real-time alerting system for COVID-19 using wearable
            data. medRxiv.
            https://www.medrxiv.org/content/10.1101/2021.06.13.21258795v1.{" "}
          </li>
          <li>
            News Center. (n.d.). Smartwatch can detect early signs of illness.
            News Center.
            https://med.stanford.edu/news/all-news/2020/12/smartwatch-can-detect-early-signs-of-illness.html.
          </li>
          <li>
            StanfordBioinformatics. (n.d.).
            StanfordBioinformatics/wearable-infection: Real-time detection of
            infection diseases using wearables. GitHub.
            https://github.com/StanfordBioinformatics/wearable-infection.{" "}
          </li>
        </div>
      </div>
    </div>
  );
}

export default Sources;
